import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import adsSlider from '../../AdsSlider'
import PublicationGuideBigCard from '../../PublicationGuideBigCard'

export const BlockPublishAds = styled.div`
  position: relative;
`
export const TitleWrapper = styled.div`
  margin-bottom: 2rem;

  @media (min-width: 960px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5rem;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 960px) {
    flex-direction: row;
    gap: 3rem;
  }
`

export const LeftWrapper = styled.div`
  @media (min-width: 960px) {
    flex: 1;
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  margin: 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans4XlBold};
  }
`

export const Card = styled(PublicationGuideBigCard)``

export const RightWrapper = styled.div`
  padding: 0 1.5rem;

  @media (min-width: 960px) {
    flex: 1;
  }
`

export const MobileText = styled.p`
  ${({ theme }) => theme.textStyles.vujahdayMedium};
  margin-top: 3rem;

  @media (min-width: 960px) {
    display: none;
  }
`
export const DesktopText = styled.p`
  ${({ theme }) => theme.textStyles.vujahdayMedium};
  display: none;

  @media (min-width: 960px) {
    display: block;
    align-self: flex-end;
  }
`

export const Slider = styled(adsSlider)`
  margin-top: 2rem;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 30px;
`
